const ACTIVE_BOOKING_ID_KEY = "activeBookingId";
const ACTIVE_BOOKING_SUMMARY_KEY = "activeBookingSummary";
const BOOKING_FLOW_CACHE_KEY = "bookingFlowCache";

const readJsonValue = (storageKey) => {
  try {
    const rawValue = localStorage.getItem(storageKey);
    return rawValue ? JSON.parse(rawValue) : null;
  } catch (_error) {
    return null;
  }
};

const writeJsonValue = (storageKey, value) => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(value));
  } catch (_error) {
    // Ignore storage failures. The booking flow can continue without persistence.
  }
};

const removeValue = (storageKey) => {
  try {
    localStorage.removeItem(storageKey);
  } catch (_error) {
    // Ignore storage failures.
  }
};

export const readBookingFlowCache = () => {
  const cache = readJsonValue(BOOKING_FLOW_CACHE_KEY);
  return cache && typeof cache === "object" ? cache : {};
};

export const readStoredBookingSummary = (bookingId = "") => {
  const normalizedBookingId = String(bookingId || "").trim();
  const bookingFlowCache = readBookingFlowCache();

  if (
    normalizedBookingId &&
    bookingFlowCache[normalizedBookingId] &&
    typeof bookingFlowCache[normalizedBookingId] === "object"
  ) {
    return bookingFlowCache[normalizedBookingId];
  }

  const activeSummary = readJsonValue(ACTIVE_BOOKING_SUMMARY_KEY);
  if (!activeSummary || typeof activeSummary !== "object") {
    return null;
  }

  if (
    normalizedBookingId &&
    String(activeSummary.bookingId || "").trim() &&
    String(activeSummary.bookingId || "").trim() !== normalizedBookingId
  ) {
    return null;
  }

  return activeSummary;
};

export const persistBookingSummary = (summary = {}) => {
  if (!summary || typeof summary !== "object") {
    return;
  }

  const bookingId = String(summary.bookingId || "").trim();
  const nextSummary = {
    ...summary,
    bookingId,
    updatedAt: Date.now(),
  };

  if (bookingId) {
    writeJsonValue(ACTIVE_BOOKING_ID_KEY, bookingId);
    writeJsonValue(ACTIVE_BOOKING_SUMMARY_KEY, nextSummary);

    const bookingFlowCache = readBookingFlowCache();
    writeJsonValue(BOOKING_FLOW_CACHE_KEY, {
      ...bookingFlowCache,
      [bookingId]: nextSummary,
    });
    return;
  }

  writeJsonValue(ACTIVE_BOOKING_SUMMARY_KEY, nextSummary);
};

export const clearActiveBookingSummary = () => {
  removeValue(ACTIVE_BOOKING_ID_KEY);
  removeValue(ACTIVE_BOOKING_SUMMARY_KEY);
};
